import { RouteObject } from 'react-router-dom';

export type CustomRouteObject = RouteObject & {
  label?: string;
  children?: CustomRouteObject[];
};

export class RouteService {
  public routes?: CustomRouteObject[];

  constructor(routes?: CustomRouteObject[]) {
    this.routes = routes;
  }

  getRoute(id: string): CustomRouteObject | undefined {
    const findRoute = (
      routes: CustomRouteObject[] | undefined,
      id: string
    ): CustomRouteObject | undefined => {
      if (!routes) return undefined;

      for (const route of routes) {
        if (id === route.id) {
          return route;
        }

        const foundInChildren = findRoute(route.children, id);
        if (foundInChildren) {
          return foundInChildren;
        }
      }
      return undefined;
    };
    return findRoute(this.routes, id);
  }
}
